import React from 'react';
import { useParams } from 'react-router';

import { PageHeader } from '@admin/components/helpers/page_header';
import { Breadcrumbs } from '@admin/components/orders/task_orders/components/breadcrumbs';
import { useTitle } from '@admin/hooks/use_title';
import { useTaskOrderContextQuery } from '@admin/schema';

import { CreatePanel } from './components/create_panel';

export const TaskOrderCreate = () => {
  useTitle('Task Order');
  const { accountID } = useParams<{ accountID: string }>();
  const { data } = useTaskOrderContextQuery({ variables: { accountID: accountID } });

  if (!data) return null;

  return (
    <>
      <PageHeader>
        <Breadcrumbs />
      </PageHeader>
      <CreatePanel accountID={accountID} />
    </>
  );
};
